import {
  DISPLAY_SQUAD_CHANGE_MODAL_FOR_CAPTAIN,
  SET_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE_TEAMS,
  SET_ROSTER_WARNINGS_FOR_CAPT_ENTRY_DETAIL,
  DISPLAY_EVENT_CHANGE_MODAL_FOR_CAPTAIN
} from './constants';

export const displaySquadChangeModal = showModal => ({
  type: DISPLAY_SQUAD_CHANGE_MODAL_FOR_CAPTAIN,
  payload: showModal
});

export const setPaymentLogHistory = paymentLogHistory => ({
  type: SET_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE_TEAMS,
  payload: paymentLogHistory
});

export const setCaptRosterWarnings = virtualEntriesToModify => ({
  type: SET_ROSTER_WARNINGS_FOR_CAPT_ENTRY_DETAIL,
  payload: virtualEntriesToModify
});

export const displayEventChangeModal = showModal => ({
  type: DISPLAY_EVENT_CHANGE_MODAL_FOR_CAPTAIN,
  payload: showModal
});



// WEBPACK FOOTER //
// ./src/features/registration/manage/actionTypes.js